export default __webpack_public_path__ + "static/media/stripe.f44fc6f4.svg";